import React, { Component } from "react";
import { connect } from "react-redux";
import axios, { CancelToken } from "axios";

import { Translate, I18n } from "react-redux-i18n";
import moment from "moment";
import { setAlert } from "../../actions/alertActions";
import PageSelector from "../utils/components/pageSelector/PageSelector";
import Select from "react-select";
import {
  getCardsStatus,
  prepareCSVDownload,
} from "../utils/Utils";
import ChoiceModal from "../utils/components/ChoiceModal";
import xlsx from "xlsx";
import "../../styles/utils/_loadingScreen.scss";
import "../../styles/components/evs/Cards.scss";
import download from "../../styles/images/download.svg";

class Cards extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;
    this.cancel = null;

    this.state = {
      loading: true,
      cards: [],
      filteredCardsList: [],
      cardsNumber: [],
      cardsLicense: [],

      selectedValueCard: {
        value: "All",
        label: I18n.t("backOffice_insights_allKey"),
      },
      selectedValueLicense: {
        value: "All",
        label: I18n.t("backOffice_insights_allKey"),
      },
      selectOptionsCard: [],
      selectOptionsLicense: [],

      cardsPage: {
        pageNumber: 1,
        resultsLimit: 10,
        totalPages: 0,
        totalEntries: 0,
      },

      modals: {
        choicePhysicalCards: false,
      },
    };

    this.handleOnChangeResultsLimit =
      this.handleOnChangeResultsLimit.bind(this);
    this.handleOnPageSwitch = this.handleOnPageSwitch.bind(this);
    this.handleOnChangeCardNumberFilter =
      this.handleOnChangeCardNumberFilter.bind(this);
    this.handleOnChangeLicensePlateFilter =
      this.handleOnChangeLicensePlateFilter.bind(this);
    this.getOptions = this.getOptions.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
    this.fetchCards();
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  fetchCards() {
    let arrCardsNumber = [];
    let arrLicense = [];

    axios
      .get("/api/private/contracts/cardsOfUser", {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
        params: {
          pageNumber: this.state.cardsPage.pageNumber,
          limiteQuery: this.state.cardsPage.resultsLimit,
        },
      })
      .then((res) => {
        this.safeSetState((prevState) => ({
          loading: false,
          cards: res.data,
          filteredCardsList: res.data,
          cardsPage: {
            ...prevState.cardsPage,
            totalPages: parseInt(res.headers.numberofpages),
            totalEntries: parseInt(res.headers.totalofentries),
          },
        }));
        if (res.data.length !== 0) {
          this.state.cards.map((item) => {
            arrCardsNumber.push(item.cardNumber);
            arrLicense.push(
              item.cardPhysicalLicensePlate.length === 0
                ? undefined
                : item.cardPhysicalLicensePlate
            );
          });
          this.safeSetState({
            cardsNumber: arrCardsNumber,
            cardsLicense: arrLicense,
          });
        }
        this.getOptions();
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  getOptions() {
    let optionsCard = [];
    let optionsLicense = [];

    const defaultValue = {
      value: "All",
      label: I18n.t("backOffice_insights_allKey"),
    };

    optionsCard = this.state.cardsNumber.map((card) => ({
      value: card,
      label: card,
    }));

    optionsLicense = this.state.cardsLicense.map((license) => ({
      value: license,
      label: license,
    }));

    optionsCard.unshift(defaultValue);
    optionsLicense.unshift(defaultValue);

    this.setState({
      selectOptionsCard: optionsCard,
      selectOptionsLicense: optionsLicense,
    });
  }

  handleOnChangeResultsLimit(e) {
    const resultsLimit = parseInt(e.target.value);
    this.safeSetState(
      (prevState) => ({
        cardsPage: { ...prevState.cardsPage, resultsLimit, pageNumber: 1 },
      }),
      this.fetchCards
    );
  }

  handleOnPageSwitch(_e, direction) {
    if (direction === "first" && this.state.cardsPage.pageNumber > 1) {
      this.safeSetState(
        (prevState) => ({
          cardsPage: { ...prevState.cardsPage, pageNumber: 1 },
        }),
        this.fetchCards
      );
    } else if (direction === "left" && this.state.cardsPage.pageNumber > 1) {
      this.safeSetState(
        (prevState) => ({
          cardsPage: {
            ...prevState.cardsPage,
            pageNumber: prevState.cardsPage.pageNumber - 1,
          },
        }),
        this.fetchCards
      );
    } else if (
      direction === "right" &&
      this.state.cardsPage.pageNumber < this.state.cardsPage.totalPages
    ) {
      this.safeSetState(
        (prevState) => ({
          cardsPage: {
            ...prevState.cardsPage,
            pageNumber: prevState.cardsPage.pageNumber + 1,
          },
        }),
        this.fetchCards
      );
    } else if (
      direction === "last" &&
      this.state.cardsPage.pageNumber < this.state.cardsPage.totalPages
    ) {
      this.safeSetState(
        (prevState) => ({
          cardsPage: {
            ...prevState.cardsPage,
            pageNumber: this.state.cardsPage.totalPages,
          },
        }),
        this.fetchCards
      );
    } else if (Number.isInteger(direction)) {
      this.safeSetState(
        (prevState) => ({
          cardsPage: { ...prevState.cardsPage, pageNumber: direction },
        }),
        this.fetchCards
      );
    }
  }

  handleOnChangeCardNumberFilter(e) {
    this.safeSetState({
      selectedValueCard: e,
      filteredCardsList:
        e.value === "All"
          ? this.state.cards
          : this.state.cards.filter((obj) => obj.cardNumber === e.value),
      selectedValueLicense: {
        value:
          e.value === "All"
            ? "All"
            : this.state.cards.filter((obj) => obj.cardNumber === e.value)[0]
                .licensePlate,
        label:
          e.value === "All"
            ? I18n.t("backOffice_insights_allKey")
            : this.state.cards.filter((obj) => obj.cardNumber === e.value)[0]
                .licensePlate,
      },
    });
  }

  handleOnChangeLicensePlateFilter(e) {
    this.safeSetState({
      selectedValueLicense: e,
      filteredCardsList:
        e.value === "All"
          ? this.state.cards
          : this.state.cards.filter(
              (obj) => obj.cardPhysicalLicensePlate === e.value
            ),

      selectedValueCard: {
        value:
          e.value === "All"
            ? "All"
            : this.state.cards.filter(
                (obj) => obj.cardPhysicalLicensePlate === e.value
              )[0].cardNumber,
        label:
          e.value === "All"
            ? I18n.t("backOffice_insights_allKey")
            : this.state.cards.filter(
                (obj) => obj.cardPhysicalLicensePlate === e.value
              )[0].cardNumber,
      },
    });
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  filterOptions(options) {
    return options.filter(
      (option) => option.value !== undefined && option.label !== undefined
    );
  }

  handleOnChoosePhysicalCards(idx) {
    this.setModal("choicePhysicalCards", false);
    const dataEv = this.prepareExportPhysicalCards();
    let ws = xlsx.utils.json_to_sheet(dataEv, {
      header: [
        I18n.t("addCard_cardNumber"),
        I18n.t("general_contractTypeUser"),
        I18n.t("general_licensePlate"),
        I18n.t("general_cardLabel"),
        I18n.t("cards_requestDate"),
        I18n.t("cards_activationDate"),
        I18n.t("contracts_network_status"),
      ],
    });
      const MAX_BASENAME_LENGTH = 31;
      const contractsTitle = I18n.t("contracts_newTitle");
      const separator = " - ";
      const companyName = this.props.accountData && this.props.accountData.name
        ? this.props.accountData.name
        : "";
      const maxCompanyPartLength = Math.max(
        0,
        MAX_BASENAME_LENGTH - (contractsTitle.length + separator.length)
      );
      const truncatedCompanyName = companyName.substring(0, maxCompanyPartLength);
      const rawSheetName = contractsTitle + separator + truncatedCompanyName;
      const sheetName = rawSheetName.substring(0, MAX_BASENAME_LENGTH);


    if (idx === 0) {
      let ws_to_csv = xlsx.utils.sheet_to_csv(ws);
      const newDataEV = ws_to_csv.split("\n").map((s) => s.split(","));
      
      const download = prepareCSVDownload(newDataEV, sheetName + ".csv");

      document.body.appendChild(download);
      download.click();
      document.body.removeChild(download);
    } else if (idx === 1) {
      let wb = xlsx.utils.book_new();

      wb.SheetNames.push(sheetName);

      wb.Sheets[sheetName] = ws;

      xlsx.writeFile(wb, `${sheetName}.xlsx`);
    }
  }

  prepareExportPhysicalCards() {
    const listOfCards = this.state.cards;
    let ListOfCardsFiltered = [];
    const cardNumber = I18n.t("addCard_cardNumber");
    const cardPhysicalName = I18n.t("general_contractTypeUser");
    const cardName = I18n.t("general_cardLabel");
    const cardPhysicalStateInfo = I18n.t("contracts_network_status");
    const requestDate = I18n.t("cards_requestDate");
    const activationDate = I18n.t("cards_activationDate");
    const cardPhysicalLicensePlate = I18n.t("general_licensePlate");
    const defaultValue = "-";

    if (listOfCards.length > 0) {
      listOfCards.forEach((cardData) => {
        let newCard = {
          [cardNumber]: cardData.cardNumber || defaultValue,
          [cardPhysicalName]: cardData?.utilizador.toString() || defaultValue,
          [cardPhysicalStateInfo]: getCardsStatus(
            cardData.cardPhysicalStateInfo
          ),
          [cardName]: cardData.cardName || defaultValue,
          [requestDate]: moment(cardData.requestDate).isValid()
            ? moment(cardData.requestDate).format("DD-MM-YYYY")
            : defaultValue,
          [activationDate]: moment(cardData.activationDate).isValid()
            ? moment(cardData.activationDate).format("DD-MM-YYYY")
            : defaultValue,
          [cardPhysicalLicensePlate]:
            cardData.cardPhysicalLicensePlate || defaultValue,
        };
        ListOfCardsFiltered.push(newCard);
      });
    }
    return ListOfCardsFiltered;
  }

  setModal(modal, bool) {
    let newModals = Object.assign({}, this.state.modals);
    newModals[modal] = bool;
    this.safeSetState({
      modals: newModals,
    });
  }

  render() {
    const filteredOptions = this.filterOptions(this.state.selectOptionsLicense);
    const isFiltered =
      this.state.selectedValueCard.value !== "All" ||
      this.state.selectedValueLicense.value !== "All";
    return !this.state.loading ? (
      <div id="cards" className="main-container">
        <div className="control-bar">
          <div className="select-label-container">
            <p>
              <Translate value="backOffice_network_forms_cardNumber" />
            </p>
            <div className="select-container">
              <Select
                value={this.state.selectedValueCard}
                options={this.state.selectOptionsCard}
                onChange={(e) => this.handleOnChangeCardNumberFilter(e)}
                placeholder="teste"
              />
            </div>
          </div>
          <div className="select-label-container">
            <p>
              <Translate value="addEv_title_plate" />
            </p>
            <div className="select-container">
              <Select
                value={this.state.selectedValueLicense}
                options={filteredOptions}
                onChange={this.handleOnChangeLicensePlateFilter}
              />
            </div>
          </div>
        </div>
        {this.state.filteredCardsList.length === 0 ? (
          <div className="no-plafonds">
            <p>{I18n.t("general_noResultsToShow")}</p>
          </div>
        ) : (
          <>
            <div className="component-container">
              <div className="table-container">
                <div className="table-header">
                  <div className="row no-gutters">
                    <div className="col-12 row no-gutters titles">
                      <div className="col-2 title">
                        {I18n.t("addCard_cardNumber")}
                      </div>
                      <div className="col title">
                        {I18n.t("general_contractTypeUser")}
                      </div>
                      <div className="col title">
                        {I18n.t("general_licensePlate")}
                      </div>
                      <div className="col title">
                        {I18n.t("general_cardLabel")}
                      </div>
                      <div className="col title">
                        {I18n.t("cards_requestDate")}
                      </div>
                      {this.props.isAdmin ? (
                        <div className="col title">
                          {I18n.t("cards_requestDateSibs")}
                        </div>
                      ) : (
                        <></>
                      )}

                      <div className="col title">
                        {I18n.t("report_emissionDate")}
                      </div>
                      <div className="col title">
                        {I18n.t("cards_activationDate")}
                      </div>
                      <div className="col-2 title">
                        {I18n.t("contracts_network_status")}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="table-values slim">
                  {this.state.filteredCardsList?.map((card, idx) => {
                    let driverNamesContent;

                    if (
                      typeof card.driversNames === "string" ||
                      card.driversNames instanceof String
                    ) {
                      driverNamesContent = card.driversNames;
                    } else if (Array.isArray(card.driversNames)) {
                      driverNamesContent =
                        card.driversNames.length > 1
                          ? I18n.t("cards_moreUsers")
                          : card.driversNames[0];
                    }

                    return (
                      <div key={card._id || idx} className="row no-gutters">
                        <div className="col-12 row no-gutters values slim">
                          <div className="col-2">{card.cardNumber}</div>
                          <div className="col">{driverNamesContent}</div>
                          <div className="col">
                            {card.cardPhysicalLicensePlate
                              ? card.cardPhysicalLicensePlate
                              : "-"}
                          </div>
                          <div className="col">{card.cardName || "-"}</div>
                          <div className="col">
                            {card.requestDate
                              ? moment(card.requestDate).format("DD-MM-YYYY")
                              : "-"}
                          </div>
                          {this.props.isAdmin ? (
                            <div className="col">
                              {card.requestThirdPartyDate
                                ? moment(card.requestThirdPartyDate).format(
                                    "DD-MM-YYYY"
                                  )
                                : "-"}
                            </div>
                          ) : (
                            <></>
                          )}

                          <div className="col">
                            {card.processedThirdPartyDate
                              ? moment(card.processedThirdPartyDate).format(
                                  "DD-MM-YYYY"
                                )
                              : "-"}
                          </div>
                          <div className="col">
                            {card.activationDate
                              ? moment(card.activationDate).format("DD-MM-YYYY")
                              : "-"}
                          </div>
                          <div className="col-2">
                            {getCardsStatus(card.cardPhysicalStateInfo)}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            <div>
              {this.state.filteredCardsList.length > 0 && (
                <div className="main-container-footer">
                  <div className="select-container">
                    <label>
                      <Translate value="history_resultsLimit" />
                    </label>
                    <select
                      name="resultsLimit"
                      value={this.state.cardsPage.resultsLimit}
                      onChange={this.handleOnChangeResultsLimit}
                      disabled={isFiltered}
                    >
                      <option value="10">10</option>
                      <option value="20">20</option>
                      <option value="30">30</option>
                    </select>
                  </div>
                  <PageSelector
                    totalPages={this.state.cardsPage.totalPages}
                    selected={this.state.cardsPage.pageNumber}
                    onPageSwitch={this.handleOnPageSwitch}
                    disabled={isFiltered}
                  />
                  <div className="exportButton">
                    <button
                      type="button"
                      className="export-btn-history"
                      onClick={() => this.setModal("choicePhysicalCards", true)}
                    >
                      <div className="export-bt-text">
                        <Translate value="exportAssets_PhysicalCards" />
                      </div>
                      <img alt="download" src={download} />
                    </button>
                  </div>
                </div>
              )}
              <ChoiceModal
                show={this.state.modals.choicePhysicalCards}
                onHide={() => this.setModal("choicePhysicalCards", false)}
                choices={[
                  { content: "CSV", name: "csv" },
                  { content: "XLSX", name: "xlsx" },
                ]}
                chooseBtnLabel="exportAssets_PhysicalCards"
                onChoose={(e) => this.handleOnChoosePhysicalCards(e)}
              />
            </div>
          </>
        )}
      </div>
    ) : (
      <div className="loading-container">
        <div className="loading-spinner">
          <div className="generic-loading">
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  preferences: state.account.preferences,
  accountData: state.account.accountData,
  userPackage: state.account.accountData.userPackage,
  isAdmin: state.account.isAdmin,
});

export default connect(mapStateToProps, { setAlert })(Cards);
